<template>
  <div >
    
  </div>
</template>

<script>

</script>

<style>
.load_patients_btn{
    background-color: #2bc551;
    color: #ffffff;
    transition: .5s all ease-in-out;
    border: none;
    border-radius: 5px;
    padding: .25rem .75rem;
    font-weight: 600;
    height: 40px;
    margin-right:20px;
}
.load_patients_btn:hover{
    background-color: #30b56a;
 
}
@media print {
  body {
    visibility: hidden;
  }
  #section-to-print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
.canfield {
    height: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start; 
    padding-top: 0; 
    margin-top: 0; 
    min-height: 885px;
}

.patient {
    padding-left: 10px;
    margin: 10px;
    font-size: 1.2rem;
}

.form-group {
    margin-bottom: 15px;
}

.form-row {
    display: flex;
    justify-content: space-between;
}

.form-group .form-control {
    width: 100%;
}

.custom-option {
    padding: 5px 10px;
    font-size: 16px;
}

.custom-submit-btn {
    background-color: #004ead;
    color: #ffffff;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    width: 160px;
    text-align: center;
    transition: .3s all ease-in-out;
    font-weight: 500;
    outline: none ;
    box-shadow: none;
}

.custom-submit-btn:hover {
    background-color: #387aca;
    color: #ffffff; 
}

.button-group {
    display: flex;
    justify-content: space-between;
  
}
.form-container {
    padding: 10px;
    background-color: #f7f7f7c5;
    border-radius: 8px;
    margin-left:20px;
    margin-right:20px;
}
.button-group .btn {
    flex: 1;
    margin: 0 5px;
    color: white; 
    padding: 10px 20px; 
    border-radius: 5px;     
    background-color: rgb(247, 246, 246); 
    color: #004ead;
    font-weight: bold;
    border: 1px solid #004ead;
}

.button-group .btn:hover {
    background-color: #eaeef3; 
}

.button-group .btn:disabled {
    background-color: #e2e3e5; 
    border-color:#e2e3e5;
    color:#383d41be;
    cursor:not-allowed;
    border:3px ;
    font-weight: bold
}
.button-report .btn{
    flex: 1;
    margin: 0 5px;
    color: white; 
    padding: 10px 20px; 
    border-radius: 5px;     
    background-color: rgb(247, 246, 246); 
    color: #004ead;
    font-weight: bold
}
.button-report .btn:hover {
    background-color: #eaeef3; 
}

.button-report .btn:disabled {
    background-color: #e2e3e5; 
    border-color:#e2e3e5;
    color:#383d41be;
    cursor:not-allowed;
    border:3px ;
    font-weight: bold
}
.patient-list {
    margin-left: 40px;
    margin-right: 40px;
}

.table {
    border-collapse: collapse; 
    width: 100%; 
    margin-top: 20px;
}

.table th,
.table td {
    border: 1px solid #ddd; 
    padding: 8px; 
    text-align: left; 
}

.table th {
    background-color: #0a61ff29;
    font-weight: bold;
    color: #1a1745;
}

.table-bordered {
    border: 2px solid #ddddddd7 !important; 
    border-radius: 7px !important; 
    overflow: hidden;
    box-shadow: 0 3px 2px #0052b64a
}
.table-bordered thead th:first-child {
    border-top-left-radius: 7px !important;
}

.table-bordered thead th:last-child {
    border-top-right-radius: 7px !important;
}

.table-bordered tbody tr:last-child td:first-child {
    border-bottom-left-radius: 7px !important;
}

.table-bordered tbody tr:last-child td:last-child {
    border-bottom-right-radius: 7px !important;
}
.table-striped tbody tr:nth-of-type(odd) {
    background-color: #f5faff; 
}


.alert-success {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
    margin-top: 15px;
    margin-left: 25px;
    margin-right: 23px;
}

.alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 10px;
    padding: 0.75rem 1.25rem;
    color: inherit;
}
.slide-fade-enter-active {
    animation: slide-in 1s ease-out forwards;
}
.slide-fade-leave-active {
    animation: fade-out 1s ease-out forwards;
}

@keyframes slide-in {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes fade-out {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
.texture{
    height: 120px;
    border-radius: 15px;
    width: 150px;
}
.file-info {
    display: flex;
    align-items: center;
    background-color: #c0d2fc; 
    padding: 8px;
    border-radius: 5px;
    margin-bottom: 10px;
    width: max-content;
}

.file-info h5 {
    margin: 0;
    padding-right: 5px;
    color: #333;
}

.file-format {
    color: #555;
    font-style: italic;
}

.file-container {
    display: flex;
    justify-content: space-between;
    gap: 15px; 
    margin-top: 20px; 
}

.file-item {
    flex: 1;
    margin-bottom: 20px;
    margin-left: 90px; 
}

.spinner-border {
    display: inline-block;
    width: 1.25rem; 
    height: 1.25rem;
    vertical-align: text-bottom;
    border: 0.15em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spinner-border .75s linear infinite;
    color: #004ead;
}

@keyframes spinner-border {
    100% {
        transform: rotate(360deg);
    }
}
.landmarks-json {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 7px;
    margin-top: 15px;
    font-family: monospace;
    white-space: pre-wrap; 
    word-wrap: break-word;
    /* margin-left:40px;
    margin-right:40px; */
    height:auto;
}

.landmarks-json h5 {
    margin-bottom: 10px;
}
.landmarks-table {
    width: 100%; 
}

.landmarks-table th,
.landmarks-table td {
    width: 370px; 
    word-wrap: break-word; 
    white-space: normal; 
}
.loading-message-container {
    background-color: #fff3cd; 
    border: 1px solid #ffeeba; 
    padding: 10px 20px; 
    border-radius: 4px; 
    width: 370px;
}

.loading-message {
    color: #856404; 
    display: flex; 
    align-items: center; 
    font-family: Arial, sans-serif; 
    margin-bottom: 10px; 
}

.loading-message i {
    margin-right: 10px; 
}

.loading-message .close {
    background: none;
    border: none;
    color: #6e5302;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    margin-left: auto; 
}

.loading-bar {
    width: 100%;
    height: 8px;
    border-radius: 10px;
    background-color: #e0e0e0; 
    overflow: hidden;
    position: relative;
}

.loading-fill {
    width: 0;
    height: 100%;
    background-color: #caab4c8f; 
    animation: loading 2s infinite;
    border-radius: 10px;
}

@keyframes loading {
    0% {
        width: 0;
    }
    50% {
        width: 100%;
    }
    100% {
        width: 0;
    }
}

.pfl-json {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 7px;
    font-family: monospace;
    white-space: pre-wrap; 
    word-wrap: break-word;
    margin-left: 40px;
    margin-right:40px;
}

.pfl-json h5 {
    margin-bottom: 10px;
}

.pfl-results {
    width: 370px; 
}

.pfl-results th,
.pfl-results td {
    width: 370px; 
    word-wrap: break-word; 
    white-space: normal; 
}
.dropzone{
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 16px;
    border: 2px dashed #B0B0B0;
    transition: .3s ease all ;
    border-radius: 1rem;
    background-color: rgba(177, 177, 177, 0.12);
}
.dropzone label{
    cursor: pointer;
}
.dropzone input {
    display: none;
}
.active-dropzone{
    color:rgb(66 91 235);
    border-color: rgb(66 91 235);
    background-color:rgba(30, 51, 170, 0.082);
}
.dropzone small{
    color: #a1a1a1;
    font-weight: 400;
}
.dropzone small::before{
    content: '';
    width: 4rem;
    height: 1px;
    display: inline-flex;
    background-color: #a1a1a1;
    justify-content: center;
    align-items: center;
    transform: translate(-4px, -4px);
}
.dropzone small::after{
    content: '';
    width: 4rem;
    height: 1px;
    display: inline-flex;
    background-color: #a1a1a1;
    justify-content: center;
    align-items: center;
    transform: translate(4px, -4px);
}
.create_btn{
    background-color: #5880e9;
    color: #ffffff;
    font-size: 13px;
    padding: .5rem;
    border: none;
    border-radius: .25rem;
    transition: all .3s ease;
    -webkit-border-radius: .25rem;
    -moz-border-radius: .25rem;
    -ms-border-radius: .25rem;
    -o-border-radius: .25rem;
}
.create_btn:hover {
    background-color: #3568eb;
    color: #ffffff; 
}

.fancy-radio input[type="radio"]:checked + span:after {
    content: "";
    position: absolute;
    left: 4px;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #004ead; 
  }
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; 
}
/* patinet modal */
.custom-modal {
  background-color: white;
  padding: 20px;
  width: 600px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-modal-header h5 {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  color: #333; 
  transition: color 0.3s ease;
}
.close-btn:hover {
  color: red;
}

.custom-modal-body {
  margin-top: 10px;
  margin-bottom: 20px;
  max-height: 400px; 
  overflow-y: auto;
  
}

.patient-row {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd; 
  transition: background-color 0.3s ease, color 0.3s ease;
}
.patient-row:not(.header-row) {
    cursor: pointer;
}
.header-row .patient-name, 
.header-row .patient-modality {
    display: flex; 
    width: 45%; 
    text-align: left; 
    color:rgb(54 105 166);
    justify-content: space-between;
}

.patient-name, .patient-modality {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  width: 45%;
}

.patient-list {
  display: flex;
  flex-direction: column;
  gap: 10px; 
  padding-left: 10px; 
}
.search-bar {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: -146px;
}
.search-input, .form-control {
  padding-left: 27px; 
  border-radius: 10px;
  height:38px;
}

.search-icon-left, .filter-icon-left {
    position:absolute;
    margin-top: 16px;
    margin-left:7px;
  transform: translateY(-50%);
  color: #007bff; 
  pointer-events: none;
}
.patient-row:not(.header-row):hover {
  background-color: #f1f1f1; 
  color: #387aca; 
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); 
}
.header-row {
    font-weight: bold;
    background-color: #ffffff;
    border-bottom: 1px solid #ccc;
}

.btn-secondary {
  background-color: #004ead;
  color: white;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-secondary:hover {
  background-color: rgb(242, 55, 55); 
  color: white; 
}
.landmarksrecord-row {
    display: flex;
    align-items: center;
    background-color: #c9edff26;
    box-shadow: 0 3px 2px #69a3e94a;
    border-radius: 4px;
    padding: 8px;
    color: #273061;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.landmarksrecord-row:hover {
    transform: translateY(-3px); 
    box-shadow: 0 4px 3px #0a47924a;
    cursor: pointer;
}
.created-date {
    margin-right: 10px;
}
.delete-icon {
    color: #dc3545; 
    cursor: pointer;
    margin-left: auto;
    transition: color 0.2s ease;
}
.delete-icon:hover {
    color: #bd2130; 
}
.AlertCloseButton {
    color: darkred;
    transition: color 0.7s ease;
  }
  
.AlertCloseButton:hover {
    color: #610202; 
  }
</style>
